<section class="px-4">
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center page_header mb-3">
      <button mat-icon-button class="back_icon" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h3 translate class="m-0 ms-2 page_header_title">Mission & Vision</h3>
    </div>
    <div class="mv-header-container">
      <button [disabled]="VisionMissionData.length >= 2" class="add_button" mat-button (click)="openUploadDialog()">
        <i class="fa-solid fa-plus"></i>
        <span translate>Add Mission/Vision</span>
      </button>
    </div>
  </div>
  <!-- Empty state -->
  <div *ngIf="VisionMissionData.length === 0" class="empty-state">
    <mat-icon class="empty-icon">info</mat-icon>
    <p translate>No mission or vision data available.</p>
  </div>

  <!-- Cards -->
  <div class="card-container" *ngIf="VisionMissionData.length > 0">
    <mat-card class="mv-card card" *ngFor="let element of VisionMissionData" matTooltip="{{ element.content_type }}">
      <!-- New image container (replaces avatar) -->
      <div class="mv-image-container">
        <img [src]="imagePath + '/' + element.image_url" alt="{{ element.content_type }}" />
      </div>

      <mat-card-header class="d-flex justify-content-between align-items-center">
        <mat-card-title class="mv-title">
          {{ element.content_type }}
        </mat-card-title>
        <button mat-icon-button class="mv-edit-btn" color="primary" matTooltip="Edit {{ element.content_type }}"
          (click)="EditopenUploadDialog(element.content_type, element)">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-card-header>

      <mat-card-content>
        <p>{{ element.content | slice : 0 : 160 }}...</p>
      </mat-card-content>

      <!-- <mat-card-actions align="end">
        <button
          mat-icon-button
          color="warn"
          matTooltip="Delete {{ element.content_type }}"
          (click)="deleteItem(element.content_type, element.id)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions> -->
    </mat-card>
  </div>
</section>